module.exports = __webpack_public_path__ + "img/embedded7.17426cfd.png";